import React, { Component } from "react";
import moment from "moment";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Switch from "../components/switch";

class CustomForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      alert: "",
      id: "",
      color_fx: 1,
      color_tipo: "MN",
      marginLeft: "133px",
      marginTop: "48px",
      height: "56px",
      height_cont: 152,
      width: "412px",
      width_cont: 1024
    };
    this.cambia = this.cambia.bind(this);
    this.switchHandle = this.switchHandle.bind(this);
    this.validaForm = this.validaForm.bind(this);
  }

  componentDidMount() {
    if (!this.props.usuario.user) {
      this.props.history.push("/login");
    }
    //console.log(this.props);
    if (this.props.printArea) {
      //console.log("HAY PRINTAREA");
      var data = this.props.printArea;
      data.id = this.props.id_prod;
      data.loading = false;
      this.setState(data);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    //console.log(this.props);
    if (prevProps.printArea != this.props.printArea) {
      var data = this.props.printArea;
      data.id = this.props.id_prod;
      data.loading = false;
      this.setState(data);
    }
    if (prevProps.productos.contador < this.props.productos.contador) {
    }
  }

  enviaDatos = e => {
    e.preventDefault();
    const datos = {
      color_fx: this.state.color_fx,
      color_tipo: this.state.color_tipo,
      marginLeft: this.state.marginLeft,
      marginTop: this.state.marginTop,
      height: this.state.height,
      height_cont: parseInt(this.state.height_cont),
      width: this.state.width,
      width_cont: parseInt(this.state.width_cont)
    };
    this.props.enviaAct(datos);
  };

  validaForm = () => {
    if (this.state.descripcion == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR LA CALLE"
      };
    } else if (this.state.nombre == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR LA ALTURA"
      };
    } else {
      return {
        resp: true,
        msj: "PASO LA VALIDACION"
      };
    }
  };

  cambia = (key, value) => {
    this.setState({ [key]: value });
  };

  switchHandle = (campo, valor) => {
    this.setState({ [campo]: valor });
  };

  render() {
    return (
      <section className="mb-5 sombraHead mt-3 clearfix">
        {this.state.alert != "" && (
          <div className="alert alert-danger" role="alert">
            {this.state.alert}
          </div>
        )}

        <h1 className="display-4">Custom Data</h1>
        
        {!this.props.productos.prod.hasOwnProperty("custom_data") &&
        <div className="alert alert-light" role="alert">
         TODAVIA NO GUARDO DATOS DE LA CUSTOMIZACION
        </div>
        }

        <form>
          <div className="form-row">
            <div className="col-md-6 mb-3">
              <label>CUSTOM TIPO</label>
              <Switch
                switchAct={this.switchHandle}
                dato="color_fx"
                off_valor={2}
                on_valor={1}
                off="FUNDE"
                on="PLENO"
                stat={this.state.color_fx}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label>COLOR</label>
              <select
                value={this.state.color_tipo}
                className="form-control form-control-sm"
                id="Tipo"
                onChange={evt => this.cambia("color_tipo", evt.target.value)}
              >
                <option value="MN">MONOCROMATICO NEGRO</option>
                <option value="MC">MONOCROMATICO COLOR</option>
                <option value="FC">FULL COLOR</option>
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="col-md-6 mb-3">
              <label>ANCHO PRINTAREA</label>
              <input
                type="text"
                className="form-control"
                id="width"
                value={this.state.width}
                placeholder="Ancho Printarea"
                onChange={evt => this.cambia("width", evt.target.value)}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label>ALTO PRINTAREA</label>
              <input
                type="text"
                className="form-control"
                id="height"
                value={this.state.height}
                placeholder="Orden"
                onChange={evt => this.cambia("height", evt.target.value)}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="col-md-6 mb-3">
              <label>MARGEN TOP PRINTAREA</label>
              <input
                type="text"
                className="form-control"
                id="marginTop"
                value={this.state.marginTop}
                placeholder="Etiqueta de la unidad"
                onChange={evt => this.cambia("marginTop", evt.target.value)}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label>MARGEN IZQ PRINTAREA</label>
              <input
                type="text"
                className="form-control"
                id="marginLeft"
                value={this.state.marginLeft}
                placeholder="Cantidad minima"
                onChange={evt => this.cambia("marginLeft", evt.target.value)}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="col-md-6 mb-3">
              <label>ANCHO IMAGEN</label>
              <input
                type="number"
                className="form-control"
                id="width_cont"
                value={this.state.width_cont}
                placeholder="Etiqueta de la unidad"
                onChange={evt => this.cambia("width_cont", evt.target.value)}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label>ALTO IMAGEN</label>
              <input
                type="number"
                className="form-control"
                id="height_cont"
                value={this.state.height_cont}
                placeholder="Cantidad minima"
                onChange={evt => this.cambia("height_cont", evt.target.value)}
              />
            </div>
          </div>

          {!this.props.stat ? (
            <button
              type="submit"
              className="btn btn-primary"
              onClick={this.enviaDatos}
            >
              Guarda
            </button>
          ) : (
            <h5>AGUARDE UN INSTANTE...</h5>
          )}
        </form>
      </section>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    usuario: state.usuario,
    productos: state.productos
  };
};

const mapDispatchToProps = dispatch => {
  return {
    /* getProductoAdmin: (id) => {
          dispatch(getProductoAdmin(id))
      },*/
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomForm);



// WEBPACK FOOTER //
// ./src/containers/admin_custom_form.js